import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { CDN } from '../api';

function Video() {
  return (
    <Box sx={{ position: 'relative', lineHeight: 0 }}>
      <video
        autoPlay loop muted playsInline
        src={`${CDN}/site/houses.mov`}
        style={{
          width: '100%',
          height: '100vh',
          objectFit: 'cover',
          display: 'block',
          filter: 'brightness(0.45)',
        }}
      />

      {/* Overlay content */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          px: 3,
          gap: 3,
        }}
      >
        <Box sx={{ pb: 2, borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
          <img
            src={`${CDN}/site/logo.PNG`}
            alt="Emerich Custom Build"
            style={{ height: 220, objectFit: 'contain', filter: 'brightness(1.1)', display: 'block' }}
          />
        </Box>
        <Box>
          <Typography
            variant="h3"
            sx={{
              color: '#fff',
              fontWeight: 700,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              fontSize: { xs: '1.6rem', md: '2.5rem' },
              textShadow: '0 2px 20px rgba(0,0,0,0.8)',
            }}
          >
            Custom Homes.
          </Typography>
          <Typography
            variant="h3"
            sx={{
              color: '#FFA13C',
              fontWeight: 700,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              fontSize: { xs: '1.6rem', md: '2.5rem' },
              textShadow: '0 2px 20px rgba(0,0,0,0.8)',
            }}
          >
            Unmatched Quality.
          </Typography>
        </Box>
        <Typography
          variant="subtitle1"
          sx={{
            color: 'rgba(255,255,255,0.75)',
            maxWidth: 480,
            fontSize: { xs: '0.95rem', md: '1.1rem' },
          }}
        >
          Bespoke homes crafted for discerning clients in Gwinnett County, Georgia.
        </Typography>
        <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
          <Button
            component={Link}
            to="/portfolio"
            variant="contained"
            size="large"
            sx={{
              backgroundColor: '#FFA13C',
              color: '#000',
              fontWeight: 700,
              px: 4,
              py: 1.5,
              borderRadius: 0,
              letterSpacing: '0.08em',
              '&:hover': { backgroundColor: '#e8912e' },
            }}
          >
            View Our Work
          </Button>
          <Button
            component={Link}
            to="/contact"
            variant="outlined"
            size="large"
            sx={{
              borderColor: 'rgba(255,255,255,0.5)',
              color: '#fff',
              fontWeight: 600,
              px: 4,
              py: 1.5,
              borderRadius: 0,
              '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255,255,255,0.05)' },
            }}
          >
            Get In Touch
          </Button>
        </Box>
      </Box>

      {/* Bottom fade */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: 120,
          background: 'linear-gradient(to top, #0d0d0d, transparent)',
        }}
      />
    </Box>
  );
}

export default Video;
